module.exports = __webpack_public_path__ + "static/img/makehole2.93ce0dd9.png";